import { TFunction } from 'i18next'

import translationKeys from '@translationKeys'

import { Tag } from '@modules/shortlist/types'

import { ImportProspectsRequestTypes, ImportProspectsStatus, ImportProspectsView } from './types'

export const IMPORT_PROSPECT_TITLES_MAP: Record<ImportProspectsView, string> = {
  [ImportProspectsView.event]: translationKeys.IMPORT_PROSPECTS,
  [ImportProspectsView.prospect]: translationKeys.IMPORT_PROSPECTS_TO,
  [ImportProspectsView.shortlist]: translationKeys.CREATE_A_NEW_CUSTOM_LIST,
}

export const IMPORT_PROSPECT_SUBTITLES_MAP: Partial<Record<ImportProspectsView, string>> = {
  [ImportProspectsView.prospect]: translationKeys.MANAGE_AND_TRACK_LIVE_PROSPECTS,
}

export const REQUEST_LABELS_MAP: Partial<Record<ImportProspectsRequestTypes, string>> = {
  [ImportProspectsRequestTypes.incoming]: translationKeys.PROSPECT_FILTER_INCOMING,
  [ImportProspectsRequestTypes.outgoing]: translationKeys.PROSPECT_FILTER_OUTGOING,
}

export const PROSPECT_STATUS_LABELS_MAP: Partial<Record<string, string>> = {
  [ImportProspectsStatus.agreed]: translationKeys.PROSPECT_FILTER_AGREED,
  [ImportProspectsStatus.canceled]: translationKeys.PROSPECT_FILTER_CANCELLED,
  [ImportProspectsStatus.declined]: translationKeys.PROSPECT_FILTER_DECLINED,
  [ImportProspectsStatus.requested]: translationKeys.PROSPECT_FILTER_REQUESTED,
}

export const PROSPECT_STATUS_ORDER = [
  ImportProspectsStatus.requested,
  ImportProspectsStatus.agreed,
  ImportProspectsStatus.declined,
  ImportProspectsStatus.canceled,
]

export const getFilters = (tags: Tag[], t: TFunction) => {
  return [
    {
      title: translationKeys.PROSPECT_FILTER_SECTION_REQUESTS as string,
      key: 'request',
      options: [
        { id: ImportProspectsRequestTypes.incoming, label: REQUEST_LABELS_MAP[ImportProspectsRequestTypes.incoming] as string },
        { id: ImportProspectsRequestTypes.outgoing, label: REQUEST_LABELS_MAP[ImportProspectsRequestTypes.outgoing] as string },
      ],
    },
    {
      title: translationKeys.PROSPECT_FILTER_SECTION_STATUS as string,
      key: 'status',
      options: PROSPECT_STATUS_ORDER.map(status => ({ id: status, label: PROSPECT_STATUS_LABELS_MAP[status] as string })),
    },
    {
      title: translationKeys.PROSPECT_FILTER_SECTION_TAGS as string,
      key: 'tag',
      options: [
        ...tags.map(tag => ({ id: tag.id, label: tag.name, color: tag.color })),
        { id: 0, label: t(translationKeys.UNTAGGED_PROSPECT_FILTER), color: '#909090' },
      ],
    },
  ]
}
